import React from 'react'
import Slider from 'react-slick'
import useContent from '../../utils/content'
import { useDataQuery } from '../../hooks/useDataQuery'
import Img from '../general/Image'

// eslint-disable-next-line react/prefer-stateless-function
const About = () => {
  const content = useContent(useDataQuery())

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  }

  const getAboutSlider = sliderContent => (
    <div className="container">
      <div className="about_gallery">
        <div className="about_gallery_outside" />
        <Slider {...settings}>
          {sliderContent.map((item, index) => {
            return (
              <Img
                // eslint-disable-next-line react/no-array-index-key
                key={`galleryAbout_img_${index}`}
                src={item.img}
                className="about_gallery_img"
              />
            )
          })}
        </Slider>
      </div>
    </div>
  )

  const getTextPart = (textArray, startIndex, finishIndex) =>
    textArray.slice(startIndex, finishIndex).map((item, i) => (
      <p
        // eslint-disable-next-line react/no-array-index-key
        key={i}
        className="general_paragraph"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: item }}
      />
    ))

  const getAboutContent = aboutContent => {
    const textArray = aboutContent.aboutParagraphs
    const sliderArray = aboutContent.galleryAbout
    const breakAfterIndex =
      textArray.length % 2
        ? (textArray.length - 1) / 2
        : textArray.length / 2 - 1

    return (
      <>
        <div className="container-small">
          <div className="about_cont">
            <h2 className="sub-title">{aboutContent.aboutTitle}</h2>
            {getTextPart(textArray, 0, breakAfterIndex + 1)}
          </div>
        </div>
        {getAboutSlider(sliderArray)}
        <div className="container-small">
          <div className="about_cont_bottom">
            {getTextPart(textArray, breakAfterIndex + 1)}
          </div>
        </div>
      </>
    )
  }

  return (
    <section className="about" id="about">
      <Img className="about_img" src={content.aboutImage} />

      {content.actionContent && (
        <div className="container-small">
          <div className="action" id="action">
            <h2
              className="sub-title"
              dangerouslySetInnerHTML={{ __html: content.actionTitle }}
            />
            <div className="content-container content-container-desktop">
              <Img className="action-img" src={content.actionImage} />
              <div className="text-cta-container">
                <div className="text-container">
                  {content.actionContent.map((item, i) => (
                    <p key={i} dangerouslySetInnerHTML={{ __html: item }} />
                  ))}
                </div>
                <a
                  target="_blank"
                  rel="noopener norefferer"
                  className="general-link"
                  href={content.contactTgLink}
                >
                  {content.actionCtaTitle}
                  <Img className="tg-icon" src="icons/telegram.svg" />
                </a>
              </div>
            </div>
            <div className="content-container content-container-mobilo">
              <p
                dangerouslySetInnerHTML={{ __html: content.actionContent[0] }}
              />
              <Img className="action-img" src={content.actionImage} />
              <div className="text-cta-container">
                <div className="text-container">
                  {content.actionContent.slice(1).map((item, i) => (
                    <p key={i} dangerouslySetInnerHTML={{ __html: item }} />
                  ))}
                </div>
                <a
                  target="_blank"
                  rel="noopener norefferer"
                  className="general-link"
                  href={content.contactTgLink}
                >
                  {content.actionCtaTitle}
                  <Img className="tg-icon" src="icons/telegram.svg" />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {getAboutContent(content)}

      <div className="container-small">
        <div className="sevices" id="sevices">
          <h2 className="sub-title">{content.aboutServicesTitle}</h2>
          <div className="sevices_gallery">
            {content.galleryServices.map((data, index) => {
              return (
                <div
                  className="sevices_gallery_items"
                  // eslint-disable-next-line react/no-array-index-key
                  key={`galleryServices_img_${index}`}
                >
                  <Img className="sevices_gallery_items_img" src={data.img} />
                  <p className="sevices_gallery_items_info">{data.info}</p>
                </div>
              )
            })}
          </div>
          {content.actionContent && (
            <a
              target="_blank"
              rel="noopener norefferer"
              className="general-link"
              href={content.servicesCtaUrl}
            >
              {content.actionMenuButton}
            </a>
          )}
        </div>
      </div>
    </section>
  )
}

export default About
